import styled from 'styled-components';
import dt from '../../../../shared/theme';

const DropdownContainer = styled.div`
  height: 36px;
  border: 1px solid ${props => dt(props).theme.secondaryColor};
  border-radius: 4px;
  background: ${props => dt(props).theme.bodyBackgroundColor};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px 8px 8px;

  &:hover {
    border: 1px solid #627484;
  }

  &.active, &.focus {
    border: 1px solid ${props => dt(props).theme.bodyColor};
  }

  ${props => dt(props).theme.isMobileOrTablet && `
    height: 40px;

    &.active {
      background-color: #EFF1F6;
    }
  `};
`;

const DropdownIcon = styled.span`
  color: ${props => dt(props).theme.bodyColor};
  font-size: 18px;
`;

const DropdownText = styled.span`
  color: ${props => dt(props).theme.bodyColor};
  font-family: ${props => dt(props).theme.fontFamilyBody};
  font-size: 14px;
  font-weight: ${props => dt(props).theme.fontWeightRegular};
  line-height: 120%;
  text-transform: uppercase;
`;

const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: ${props => dt(props).theme.bodyBackgroundColor};

  ${props => !dt(props).theme.isMobileOrTablet && `
    position: absolute;
    border: 1px solid #D7DFE7;
    border-radius: 6px;
    box-shadow: 0px 12px 12px rgba(50, 50, 71, 0.08), 0px 16px 24px rgba(50, 50, 71, 0.08);
    margin-top: 8px;
    padding: 24px 24px 24px 16px;
  `};

  ${props => dt(props).theme.isMobileOrTablet && `
    position: fixed;
    top: 100%;
    left: 0;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    padding: 100px 20px 20px;

    @keyframes slideUp {
      from {
        top: 100%;
      }
      to {
        top: 48px;
      }
    }

    @keyframes slideDown {
      from {
        top: 48px;
      }
      to {
        top: 100%;
      }
    }

    &.slide-up {
      top: 48px;
      animation: slideUp 0.2s ease-out;
    }

    &.slide-down {
      top: 100%;
      animation: slideDown 0.2s ease-in;
    }
  `};
`;

const OptionsContainerText = styled.div`
  color: ${props => dt(props).theme.bodyColor};
  font-family: ${props => dt(props).theme.fontFamilyBody};
  font-size: 32px;
  font-weight: ${props => dt(props).theme.fontWeightMedium};
  line-height: 120%;
`;

const CrossButton = styled.div`
  position: absolute;
  top: 36px;
  right: 26px;
  font-size: 28px;
  cursor: pointer;
`;

const Option = styled.div`
  display: flex;
  width: 100%;
  height: 40px;
  color: ${props => dt(props).theme.secondaryColor};
  font-family: ${props => dt(props).theme.fontFamilyBody};
  font-size: 16px;
  text-transform: uppercase;
  padding: 12px 12px 12px 8px;
  cursor: pointer;

  &.selected {
    color: ${props => dt(props).theme.bodyColor};
  }

  &:hover {
    border-radius: 6px;
    background: #F5F6F9;
  }

  ${props => dt(props).theme.isMobile && `
    margin-bottom: 16px;
  `};
`;

const OptionText = styled.div`
  font-weight: ${props => dt(props).theme.fontWeightHeavy};

  span {
    font-weight: ${props => dt(props).theme.fontWeightRegular};
  }
`;

export {
  CrossButton,
  DropdownContainer,
  DropdownIcon,
  DropdownText,
  OptionsContainer,
  OptionsContainerText,
  Option,
  OptionText,
};
